import { fetchImageAsDataUrl } from 'JS/shared/helpers/loadSvgImage';
import { encodeSvgFromString } from 'JS/shared/helpers/svgToDataUrl';

import getUserImageByAssetId from './UserImageProvider';
import { getImageById } from './ImageLibrary';
import uploadingAssetProvider from './UploadingAssetProvider';

const parser = new DOMParser();

const getRecolorDefaults = xml => {
  const svg = parser.parseFromString(xml, 'image/svg+xml').querySelector('svg');
  const primaryColor = svg.querySelector(`#vs-primary [fill]:first-child`)?.getAttribute('fill');
  const secondaryColor = svg.querySelector(`#vs-secondary [fill]:first-child`)?.getAttribute('fill');
  const skinColor = svg.querySelector(`#vs-skin [fill]:first-child`)?.getAttribute('fill');
  const hairColor = svg.querySelector(`#vs-hair [fill]:first-child`)?.getAttribute('fill');

  const outlines = svg.querySelector(`#vs-outline`);
  let strokeColor;

  if (outlines) {
    const outlinesChildren = Array.from(outlines.children);
    let strokeColors = [];
    for (const path of outlinesChildren) {
      strokeColors.push(path.getAttribute('stroke'));
    }
    let uniqueStrokeColors = [...new Set(strokeColors)];
    if (uniqueStrokeColors.length === 1) {
      strokeColor = uniqueStrokeColors[0];
    }
  }

  const highlightColor = svg.querySelector(`#vs-highlight [fill]:first-child`)?.getAttribute('fill');
  const recolorDefaults = {
    ...(primaryColor && { primaryColor }),
    ...(secondaryColor && { secondaryColor }),
    ...(skinColor && { skinColor }),
    ...(hairColor && { hairColor }),
    ...(strokeColor && { strokeColor }),
    ...(highlightColor && { highlightColor })
  };
  return recolorDefaults;
};

const recolorSvg = (svg, recolor) => {
  const svgDoc = parser.parseFromString(svg, 'image/svg+xml').querySelector('svg');

  if (recolor.primaryColor) {
    svgDoc
      .querySelectorAll('#vs-primary, #vs-primary [fill]')
      .forEach(el => el.setAttribute('fill', recolor.primaryColor));
  }
  if (recolor.secondaryColor) {
    svgDoc
      .querySelectorAll('#vs-secondary, #vs-secondary [fill]')
      .forEach(el => el.setAttribute('fill', recolor.secondaryColor));
  }
  if (recolor.skinColor) {
    svgDoc.querySelectorAll('#vs-skin, #vs-skin [fill]').forEach(el => el.setAttribute('fill', recolor.skinColor));
  }
  if (recolor.hairColor) {
    svgDoc.querySelectorAll('#vs-hair, #vs-hair [fill]').forEach(el => el.setAttribute('fill', recolor.hairColor));
  }
  if (recolor.highlightColor) {
    svgDoc.querySelectorAll('#vs-highlight [fill]').forEach(el => el.setAttribute('fill', recolor.highlightColor));
  }
  if (recolor.strokeColor) {
    svgDoc.querySelectorAll('#vs-outline [stroke]').forEach(el => el.setAttribute('stroke', recolor.strokeColor));
  }
  const newSvg = new XMLSerializer().serializeToString(svgDoc);
  return newSvg;
};

export const getProviderForType = (type = 'user') => {
  if (type === 'library') {
    return getImageById;
  } else if (type === 'upload') {
    return uploadingAssetProvider.getUrlById;
  } else {
    return getUserImageByAssetId;
  }
};

export const getUrlProviderForContentType = ({ provider, contentType }) => {
  const providerFn = getProviderForType(provider);
  if (contentType === 'image/svg+xml') {
    return async (assetId, thumb, _contentType, recolor) => {
      const url = await providerFn(assetId, thumb);
      const originalXml = await fetchImageAsDataUrl(url);
      const xml = recolor ? recolorSvg(originalXml, recolor) : originalXml;
      return encodeSvgFromString(xml);
    };
  } else {
    return providerFn;
  }
};

// TODO: refactor and tidy up api
export const getSvgUrlWithDefaults = async ({ provider, contentType, assetId, recolor }) => {
  const url = await getProviderForType(provider)(assetId, false, contentType, recolor);
  if (contentType !== 'image/svg+xml')
    return {
      url,
      recolorDefaults: {}
    };
  const originalXml = await fetchImageAsDataUrl(url);
  const recolorDefaults = getRecolorDefaults(originalXml);
  const xml = recolor ? recolorSvg(originalXml, recolor) : originalXml;

  return {
    url: encodeSvgFromString(xml),
    recolorDefaults
  };
};
